import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { DetailResponsibleCrubs } from 'practice/constants/responsabile-crubs';
import FormResponsible, { FormResponsibleVM } from 'practice/components/resonsible/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { ResponsibleData } from 'shell/models/type-responsible';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { responsibleResponseTransformer } from 'practice/utils/responsible-response-transformer';

const DetailResponsible = (): ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-responsabile');
  });

  const [responsible] = useHttpFetch<HttpResponse<ResponsibleData>, FormResponsibleVM>(
    `${__PRACTICE_API_URL__}/pratiche/responsabile/${params?.tyPratica}-${params?.codServizio}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: responsibleResponseTransformer,
    }
  );

  return (
    <Fragment>
      <Breadcrumbs items={DetailResponsibleCrubs} />
      {responsible.isLoading || responsible.pristine || responsible.hasErrors ? undefined : (
        <FormResponsible
          title="Dettaglio Responsabile"
          onCancel={onCancel}
          disabled
          initialValues={responsible?.data as FormResponsibleVM}
        />
      )}
    </Fragment>
  );
};

DetailResponsible.displayName = 'Edit Responsible Page component';

export default DetailResponsible;
